import { useState } from 'react'
import { copyHtmlToClipBoard, cx } from '@/utils/strings'
import DOMPurify from 'isomorphic-dompurify'

export interface Props {
  id?: string
  text?: string
  theme?: 'dark' | 'light'
  language?: string
  className?: string
}

export default function CopyButton({ id, text, theme = 'dark', className }: Props) {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    if (text) {
      navigator.clipboard.writeText(text)
    } else if (id) {
      const content = document.getElementById(id)?.innerHTML || ''
      copyHtmlToClipBoard(DOMPurify.sanitize(content))
    }
    setCopied(true)
    setTimeout(() => setCopied(false), 3000)
  }

  if (!text && !id) return null
  return (
    <button
      type="button"
      className={cx(
        'flex items-center justify-center opacity-80 hover:opacity-100 transition-opacity text-sm',
        className
      )}
      title="Copy Text"
      aria-label="Copy Text"
      onClick={handleCopy}
      onKeyDown={(e: React.KeyboardEvent<HTMLButtonElement>) => e.key === 'Enter' && handleCopy()}
    >
      <span className="italic mr-2">{copied ? 'Copied!' : 'Copy'}</span>
      <span className="font-bwi">&#xe905;</span>
    </button>
  )
}
